<app-modal-dialog [show]="showModal" size="auto" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Detalle de Compra Pendiente por Recibir</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>

    <div class="modal-body" modal-body>
        <div class="d-flex flex-column" *ngIf="purchaseV!=null">
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Serie: <span class="font-medium">{{purchaseV.series}}</span></h6>
                <h6 class="font-bold">Numero: <span class="font-medium">{{purchaseV.number}}</span></h6>
            </div>
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Proveedor: <span class="font-medium">{{purchaseV.providerData.name}}</span></h6>
                <h6 class="font-bold">NIT: <span class="font-medium">{{purchaseV.providerData.nit}}</span></h6>
            </div>
            <div class="d-flex flex-col flex-wrap gap-4">
                <h6 class="font-bold">Bodega: <span class="font-medium">{{purchaseV.warehouseData.name}}</span></h6>
                <h6 class="font-bold">Fecha: <span class="font-medium">{{convertToString(purchaseV.date)}}</span></h6>
            </div>
        </div>
        <div class="row">
            <div class="table-responsive" style="margin-bottom: 0;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="ta">
                                #
                            </th>
                            <th class="ta">
                                Nombre
                            </th>
                            <th class="ta">
                                Cantiad
                            </th>
                            <th class="ta">
                                Precio
                            </th>
                            <th class="ta">
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of details; let i = index">
                            <tr>
                                <td>{{i+1}}</td>
                                <td>{{item.productName}}</td>
                                <td>{{item.quantity.toFixed(2)}}</td>
                                <td><span>Q</span> {{item.price.toFixed(2)}}</td>
                                <td class="text-right"><span>Q</span> {{subtotal(item.quantity,item.price)}}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="4"> Total</td>
                            <td class="font-bold text-right"><span>Q</span> {{total}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
					
        </div>
    </div>
</app-modal-dialog>
